import { LOANS_ROUTING_PARAMS, LoansPaths } from 'app/configs/routesConfig/loans';

import { FeeRecommendationItemStatus } from 'constants/feeRecommendations';
import { DocumentsSubtabRouteParam, LoanApplicationTabRouteParam } from 'constants/loanApplication';

export const getPendingItemIds = session =>
  session.items
    .filter(item => item.status === FeeRecommendationItemStatus.PENDING)
    .map(({ id }) => id);

export const getReviewPendingKey = (action, id) => `${action}:${id}`;

// Deep link to the document the AI read the recommendations from (the loan's Documents tab honors ?documentId=).
export const getSourceDocumentPath = (applicationId, documentId) =>
  `${LoansPaths.applicationManagement.generatePath({
    [LOANS_ROUTING_PARAMS.applicationId]: applicationId,
    [LOANS_ROUTING_PARAMS.tab]: LoanApplicationTabRouteParam.DOCUMENTS,
    [LOANS_ROUTING_PARAMS.subtab]: DocumentsSubtabRouteParam.DOCUMENTS,
  })}?documentId=${encodeURIComponent(documentId)}`;
